<template>
    <pop-in @close="onPopinClose">
        <template #popin-body>
            <div class="email-popin-body">
                <div>
                    <span>{{ title }}</span>
                </div>
                <a :href="emailAddressHref">{{ emailAddressLabel }}</a>
            </div>
        </template>
    </pop-in>
</template>

<script setup lang="ts">
import { computed } from "vue";
import PopIn from "@/templates/Popin.vue";

const props = withDefaults(defineProps<{
    title?: string;
    user?: string;
    domain?: string;
}>(), {
    title: "",
    user: "",
    domain: ""
});

const emit = defineEmits<{
    close: [];
}>();

function onPopinClose(): void {
    emit("close");
}

const emailAddressLabel = computed(() => `${props.user}@${props.domain}`);
const emailAddressHref = computed(() => `mailto:${props.user}@${props.domain}`);
</script>

<style>
.email-popin-body {
    display: flex;
    flex-direction: column;
    margin: 1em;
}
</style>
